<template>
  <div class="main-home">
    <div>
      <NavBar/>   
    </div>


    <div class="container-cover">
      <div class="container-fluid home">
        <CoverHome/>
      </div>
    </div>

    <div class="tooltip tooltip-network"></div>

    
      <!--- Inicio story -->
    <div class="container-fluid story-container">
      <div class="row justify-content-center">
        <div class="col-11 col-md-8 col-lg-6 col-xl-5">
          <div class="dates text-center mt-5">
            <div class="mt-5">
              <img src="@/assets/foco.jpeg" alt="logo">
              <div class="text-center mt-3 mb-2">
                <div class="authors">Valeria Vicente Vásquez, Gabriela Medrano y Ricardo Dávila</div>
                <div class="published-date mt-2">
                <span>26 de noviembre del 2024</span>
              </div>            
              </div>              
            </div>
            

            <div class="social-story pt-2 mb-5">
              <SocialSharing/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid story-container"  v-for="(item, ix) in items_group" :key="item.item_id">
      <div class="row justify-content-center">
        <div class="col-12 storytelling" :class="{'p-0': item[0].item_type==`ChordMedias` || item[0].item_type==`Carousel`}">
          <div>
            <DataIframe v-if="item[0].item_type=='DataIframe'" :value="item[0]" :iframe-src="item[0].text"/>            
            <SingleImage :data-section="`section-${ix}`" class="container-item" v-if="item[0].item_type==`SingleImage`" :cardText="item[0]"/>
            <SingleVideo :data-section="`section-${ix}`"  class="container-item" v-if="item[0].item_type==`SingleVideo`" :cardText="item[0]"/>
            <SingleInteractive :data-section="`section-${ix}`"  class="container-item" v-if="item[0].item_type==`SingleInteractive`" :cardText="item[0]"/>
            <ScrollCard :data-section="`section-${ix}`"  class="container-item" v-if="item[0].item_type==`ScrollCard`" :cardText="item[0]"/>
            <ScrollText :data-section="`section-${ix}`"  class="container-item" v-if="item[0].item_type==`ScrollText`" :cardText="item"/>
            <ChordMedias :data-section="`section-${ix}`"  class="container-item" v-if="item[0].item_type==`ChordMedias`" :cardText="item" />
            <Carousel :data-section="`section-${ix}`"  class="container-item" v-if="item[0].item_type==`Carousel`" :cardText="item" />
            <VideoClip01 :data-section="`section-${ix}`"  class="container-item" v-if="item[0].item_type==`VideoClip01`" :cardText="item" />
            <VideoClip02 :data-section="`section-${ix}`"  class="container-item" v-if="item[0].item_type==`VideoClip02`" :cardText="item" />
            
            
          </div>
        </div>
      </div>
    </div>
      <!---Fin story-->     
    
      <div class="enlaces">
      <Creditos/>
    </div>
  </div>
</template>

<script>

import { groupBy } from 'lodash'

import ChordMedias from '@/components/ChordMedias.vue'
import NavBar from '@/components/NavBar.vue'
import Carousel from '@/components/Carousel.vue'
import CoverHome from '@/components/CoverHome.vue'
import DataIframe from '@/components/DataIframe.vue'
import ScrollText from '@/components/ScrollText.vue'
import ScrollCard from '@/components/ScrollCard.vue'
import SingleInteractive from '@/components/SingleInteractive.vue'
import SingleImage from '@/components/SingleImage.vue'
import SingleVideo from '@/components/SingleVideo.vue'
import Creditos from '@/components/Creditos.vue'
import SocialSharing from '@/components/SocialSharing.vue'
import VideoClip01 from '@/components/VideoClip01.vue'
import VideoClip02 from '@/components/VideoClip02.vue'




export default {
  name: 'Home',
  components: {
    NavBar,    
    DataIframe,    
    ScrollText,
    SingleVideo,    
    SingleInteractive,
    SingleImage,
    CoverHome,
    Creditos,
    ScrollCard,
    SocialSharing,
    ChordMedias,
    Carousel,
    VideoClip01,
    VideoClip02

  },
  data() {
    return {
      current_year: '2003',
      show_bar: false,
      analytics: [],
      radius: 300,
      radiusB: 360
    }
  },
  mounted() {    
    window.addEventListener('scroll', ()=> {
      window.requestAnimationFrame( ()=> {
        this.scrollAnimation(window.scrollY)
      })          
    })

  },
  computed: {
    items_group() {
      return groupBy(this.$t('items'), 'groupby')
    }
  },
  methods: {
    getAllContainer() {
      let  nuevo = document.querySelectorAll('.container-item')
      let triggers = Array.from(nuevo).map(item=>{
        return {
          name: item.dataset.name,
          start: item.offsetTop,
          end: item.offsetTop+item.offsetHeight,
          element: item,
          section: item.dataset.section
        }
      })
      return triggers
    },
    scrollAnimation(scroll) {

      if(document.querySelector(`.mapa-offset-top`)) {
              
        const top_mapa = document.querySelector(`.mapa-offset-top`).offsetTop

        if(scroll > (window.innerHeight*1.2)) {
          document.querySelector('.contenido').style.opacity = 1

          if(scroll > (top_mapa+200)){
            if(document.querySelector(`.cover .cover-picture`)) {
              document.querySelector(`.cover .cover-picture`).style.opacity = 0
              document.querySelector(`.map-container`).style.visibility = `visible`
              document.querySelector(`.map-container`).style.opacity = 1
            }
          } else if (scroll < (top_mapa+200)) {
            document.querySelector(`.cover .cover-picture`).style.opacity = 0.5
            document.querySelector(`.map-container`).style.visibility = `hidden`
            document.querySelector(`.map-container`).style.opacity = 0
          }

          
        }

      }
    }
  }
  
}
</script>